import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=4e7e706a&scoped=true"
import script from "./left-menu.vue?vue&type=script&lang=js"
export * from "./left-menu.vue?vue&type=script&lang=js"
import style0 from "./left-menu.vue?vue&type=style&index=0&id=4e7e706a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e706a",
  null
  
)

export default component.exports